// @flow

import React from "react";
import ReactDOM from "react-dom";

import EventListingFilters from "../components/filters/EventListingFilters";
import SearchFilters from "../components/filters/SearchFilters";
import VenueListingFilters from "../components/filters/VenueListingFilters";
import NewsListingFilters from "../components/filters/NewsListingFilters";

const els = document.querySelectorAll(".filters__filters");
els.forEach((el: HTMLElement) => {
    const filters = window.filters;
    if (filters) {
        let FilterComponent = null;
        switch (filters.type) {
            case "event-listing":
                FilterComponent = EventListingFilters;
                break;
            case "search-page":
                FilterComponent = SearchFilters;
                break;
            case "venue-listing":
                FilterComponent = VenueListingFilters;
                break;
            case "news-listing":
                FilterComponent = NewsListingFilters;
                break;
            default:
                break;
        }
        if (FilterComponent) {
            ReactDOM.render(
                <FilterComponent
                    data={filters.data}
                    resetUrl={filters.reset_url}
                />,
                el
            );
        }
    }
});
